import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOrderDocument } from '~/types/document/models'

// Seeded with one document so an email written on its Activities tab has one to
// attach (Attach <Record> Documents, modules/email.ts).

export const {
  getDocumentListData: getOrderDocumentListData,
  getDocumentDataById: getOrderDocumentDataById,
  getDocumentListDataByParentId: getOrderDocumentListDataByOrderId,
} = makeDocumentMockData<IOrderDocument>({
  entityName: 'order',
  storageKeyPrefix: 'order',
  getStartingListData: async () => [
    {
      id: 'XXORDD0001',
      hrid: 'ORDD0001',
      order: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      descr: 'Order info',
      documentType: { id: 9, label: 'Order Info' },
      filename: 'target-big-mac-order-info.pdf',
      filetype: 'application/pdf',
      filesize: 158720,
      fileChecksum: '9e04b7c2d15a6f38e7c0a24b91d3f5c8',
      fileChecksumAlgorithm: 'md5',
      uploadedByTeamMember: { id: 'XXTM0001', label: 'Meryl Streep' },
      fileUrlPath: '/files/XXORDD0001',
      createdAt: '2023-02-01T18:05:00Z',
      version: '1',
      canBeDeleted: true,
    },
  ],
})
